import { render, staticRenderFns } from "./VirtualMachineView.vue?vue&type=template&id=0d89400c&scoped=true&%3Akey=vm.name"
import script from "./VirtualMachineView.vue?vue&type=script&lang=ts"
export * from "./VirtualMachineView.vue?vue&type=script&lang=ts"
import style0 from "./VirtualMachineView.vue?vue&type=style&index=0&id=0d89400c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d89400c",
  null
  
)

export default component.exports